<div class="toolbar-grid-container">
  <ng-container *ngTemplateOutlet="leftSideTemplate"></ng-container>
  <span class="toolbar-spacer"></span>
  <ng-container *ngTemplateOutlet="rightSideTemplate"></ng-container>
</div>
